/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { isXandrServing } from '@bingads-webui-campaign-react/constants';
import template from './campaign-bid-strategy-template.pug';

export class CampaignBidStrategyTypeColumn extends CampaignuiBaseColumn {
  constructor(options) {
    const {
      i18n,
      helpId = 'pop_BA_CampaignGrids_BidStrategy',
    } = options;
    const title = i18n.getString('ColumnName_BidStrategyType');
    const helpAriaLabel = i18n.getString('Click to learn more about {{item}}', { item: title });

    super({
      name: 'DisplayBiddingStrategyType',
      property: ['BiddingScheme', 'CampaignSubType'],
      title,
      sortable: 'DisplayBiddingStrategyType',
      type: 'string',
      bodyClasses: ['grid-column-BidStrategyType'],
      helpId,
      helpAriaLabel,
    });
    this.i18n = i18n;
    this.permissions = options.permissions;
  }

  pickProperty(item) {
    let type = _.result(item.BiddingScheme, 'Type', null);

    if (isXandrServing(item.CampaignSubType, item.CampaignSettings)) {
      if (type === 'ManualCpm') {
        type = 'ViewableCpm';
      } else if (type === 'ManualCpv') {
        type = 'Cpcv';
      }
    }

    this.CampaignType = item.CampaignType;
    this.BiddingScheme = item.BiddingScheme;

    return type;
  }

  template({ value }) {
    return template({
      DisplayBiddingStrategyType: value,
      CampaignType: this.CampaignType,
      BiddingScheme: this.BiddingScheme,
      i18n: this.i18n,
    });
  }
}
